export default "__VITE_ASSET__6X6PcqLd__"